/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "DeliveryMethod": [
      "ShippingMethod",
      "Warehouse"
    ],
    "Event": [
      "AddressCreated",
      "AddressDeleted",
      "AddressUpdated",
      "AppDeleted",
      "AppInstalled",
      "AppStatusChanged",
      "AppUpdated",
      "AttributeCreated",
      "AttributeDeleted",
      "AttributeUpdated",
      "AttributeValueCreated",
      "AttributeValueDeleted",
      "AttributeValueUpdated",
      "CalculateTaxes",
      "CategoryCreated",
      "CategoryDeleted",
      "CategoryUpdated",
      "ChannelCreated",
      "ChannelDeleted",
      "ChannelStatusChanged",
      "ChannelUpdated",
      "CheckoutCreated",
      "CheckoutFilterShippingMethods",
      "CheckoutMetadataUpdated",
      "CheckoutUpdated",
      "CollectionCreated",
      "CollectionDeleted",
      "CollectionMetadataUpdated",
      "CollectionUpdated",
      "CustomerCreated",
      "CustomerMetadataUpdated",
      "CustomerUpdated",
      "DraftOrderCreated",
      "DraftOrderDeleted",
      "DraftOrderUpdated",
      "FulfillmentApproved",
      "FulfillmentCanceled",
      "FulfillmentCreated",
      "FulfillmentMetadataUpdated",
      "GiftCardCreated",
      "GiftCardDeleted",
      "GiftCardMetadataUpdated",
      "GiftCardStatusChanged",
      "GiftCardUpdated",
      "InvoiceDeleted",
      "InvoiceRequested",
      "InvoiceSent",
      "MenuCreated",
      "MenuDeleted",
      "MenuItemCreated",
      "MenuItemDeleted",
      "MenuItemUpdated",
      "MenuUpdated",
      "OrderCancelled",
      "OrderConfirmed",
      "OrderCreated",
      "OrderFilterShippingMethods",
      "OrderFulfilled",
      "OrderFullyPaid",
      "OrderMetadataUpdated",
      "OrderUpdated",
      "PageCreated",
      "PageDeleted",
      "PageTypeCreated",
      "PageTypeDeleted",
      "PageTypeUpdated",
      "PageUpdated",
      "PaymentAuthorize",
      "PaymentCaptureEvent",
      "PaymentConfirmEvent",
      "PaymentListGateways",
      "PaymentProcessEvent",
      "PaymentRefundEvent",
      "PaymentVoidEvent",
      "PermissionGroupCreated",
      "PermissionGroupDeleted",
      "PermissionGroupUpdated",
      "ProductCreated",
      "ProductDeleted",
      "ProductMediaCreated",
      "ProductMediaDeleted",
      "ProductMediaUpdated",
      "ProductMetadataUpdated",
      "ProductUpdated",
      "ProductVariantBackInStock",
      "ProductVariantCreated",
      "ProductVariantDeleted",
      "ProductVariantMetadataUpdated",
      "ProductVariantOutOfStock",
      "ProductVariantStockUpdated",
      "ProductVariantUpdated",
      "SaleCreated",
      "SaleDeleted",
      "SaleToggle",
      "SaleUpdated",
      "ShippingListMethodsForCheckout",
      "ShippingPriceCreated",
      "ShippingPriceDeleted",
      "ShippingPriceUpdated",
      "ShippingZoneCreated",
      "ShippingZoneDeleted",
      "ShippingZoneMetadataUpdated",
      "ShippingZoneUpdated",
      "StaffCreated",
      "StaffDeleted",
      "StaffUpdated",
      "ThumbnailCreated",
      "TransactionActionRequest",
      "TransactionItemMetadataUpdated",
      "TranslationCreated",
      "TranslationUpdated",
      "VoucherCreated",
      "VoucherDeleted",
      "VoucherMetadataUpdated",
      "VoucherUpdated",
      "WarehouseCreated",
      "WarehouseDeleted",
      "WarehouseMetadataUpdated",
      "WarehouseUpdated"
    ],
    "IssuingPrincipal": [
      "App",
      "User"
    ],
    "Job": [
      "AppInstallation",
      "ExportFile",
      "Invoice"
    ],
    "Node": [
      "Address",
      "Allocation",
      "App",
      "AppExtension",
      "AppInstallation",
      "AppToken",
      "Attribute",
      "AttributeTranslatableContent",
      "AttributeTranslation",
      "AttributeValue",
      "AttributeValueTranslatableContent",
      "AttributeValueTranslation",
      "Category",
      "CategoryTranslatableContent",
      "CategoryTranslation",
      "Channel",
      "Checkout",
      "CheckoutLine",
      "Collection",
      "CollectionChannelListing",
      "CollectionTranslatableContent",
      "CollectionTranslation",
      "CustomerEvent",
      "DigitalContent",
      "DigitalContentUrl",
      "EventDelivery",
      "EventDeliveryAttempt",
      "ExportEvent",
      "ExportFile",
      "Fulfillment",
      "FulfillmentLine",
      "GiftCard",
      "GiftCardEvent",
      "GiftCardTag",
      "Group",
      "Invoice",
      "Menu",
      "MenuItem",
      "MenuItemTranslatableContent",
      "MenuItemTranslation",
      "Order",
      "OrderDiscount",
      "OrderEvent",
      "OrderLine",
      "Page",
      "PageTranslatableContent",
      "PageTranslation",
      "PageType",
      "Payment",
      "Product",
      "ProductChannelListing",
      "ProductMedia",
      "ProductTranslatableContent",
      "ProductTranslation",
      "ProductType",
      "ProductVariant",
      "ProductVariantChannelListing",
      "ProductVariantTranslatableContent",
      "ProductVariantTranslation",
      "Sale",
      "SaleChannelListing",
      "SaleTranslatableContent",
      "SaleTranslation",
      "ShippingMethod",
      "ShippingMethodChannelListing",
      "ShippingMethodPostalCodeRule",
      "ShippingMethodTranslatableContent",
      "ShippingMethodTranslation",
      "ShippingMethodType",
      "ShippingZone",
      "ShopTranslation",
      "StaffNotificationRecipient",
      "Stock",
      "TaxClass",
      "TaxConfiguration",
      "Transaction",
      "TransactionEvent",
      "TransactionItem",
      "User",
      "Voucher",
      "VoucherChannelListing",
      "VoucherTranslatableContent",
      "VoucherTranslation",
      "Warehouse",
      "Webhook"
    ],
    "ObjectWithMetadata": [
      "Address",
      "App",
      "Attribute",
      "Category",
      "Checkout",
      "CheckoutLine",
      "Collection",
      "DigitalContent",
      "Fulfillment",
      "GiftCard",
      "Invoice",
      "Menu",
      "MenuItem",
      "Order",
      "OrderLine",
      "Page",
      "PageType",
      "Payment",
      "Product",
      "ProductMedia",
      "ProductType",
      "ProductVariant",
      "Sale",
      "ShippingMethod",
      "ShippingMethodType",
      "ShippingZone",
      "TaxClass",
      "TaxConfiguration",
      "TransactionItem",
      "User",
      "Voucher",
      "Warehouse"
    ],
    "TaxSourceLine": [
      "CheckoutLine",
      "OrderLine"
    ],
    "TaxSourceObject": [
      "Checkout",
      "Order"
    ],
    "TranslatableItem": [
      "AttributeTranslatableContent",
      "AttributeValueTranslatableContent",
      "CategoryTranslatableContent",
      "CollectionTranslatableContent",
      "MenuItemTranslatableContent",
      "PageTranslatableContent",
      "ProductTranslatableContent",
      "ProductVariantTranslatableContent",
      "SaleTranslatableContent",
      "ShippingMethodTranslatableContent",
      "VoucherTranslatableContent"
    ],
    "TranslationTypes": [
      "AttributeTranslation",
      "AttributeValueTranslation",
      "CategoryTranslation",
      "CollectionTranslation",
      "MenuItemTranslation",
      "PageTranslation",
      "ProductTranslation",
      "ProductVariantTranslation",
      "SaleTranslation",
      "ShippingMethodTranslation",
      "VoucherTranslation"
    ],
    "_Entity": [
      "Address",
      "App",
      "Category",
      "Collection",
      "Group",
      "PageType",
      "Product",
      "ProductMedia",
      "ProductType",
      "ProductVariant",
      "User"
    ]
  }
};
      export default result;
    